import type { Part } from '@prisma-client';
import { QuoteLineFullDTO } from '@prisma-types';
import { ERPDB } from '@snap-types/models/site/enums';
import { Decimal } from '@snap-types/types/decimal';

export const QUOTE_LINE_DESCRIPTION_MAX_LENGTH = 120;

// Visual: QUOTE_LINE.CUSTOMER_PART_ID nvarchar(30)
export const QUOTE_LINE_CUSTOMER_PART_ID_MAX_LENGTH = 30;

// NOTE: This is the Quote version of the SNAP Type defined at
// @api/actions/view-snap-quote/types.ts
type OrderedQuoteLine = {
  createdAt: Date;
  invoicedQuantity: Decimal | null;
  orderId: string;
  orderQuantity: Decimal;
  partId?: string;
  quoteLineNumber: number | null;
  unitPrice: Decimal;
};

export interface QuoteLineWithOrderedLine extends QuoteLineFullDTO {
  orderedLine?: OrderedQuoteLine | null;
}

export type QuoteLineFull = QuoteLineWithOrderedLine;

export type QuotePrice = {
  quantity: number;
  unitPrice: number;
};

/**
 * The data we parse from a spreadsheet file is roughly the data required
 * to create a quote line item, but without the `quoteId` and
 * `erpDB` (which the spreadsheet and importer won't know, but
 * the calling API or UI code will).
 */
export type ParsedQuoteLine = {
  lineNumber: number;
  partId: string;
  partCreatedBySnap: boolean;
  description: string | null;
  customerPartId: string | null;
  finishedPartId: string;
  erpDB: ERPDB | null;
  leadTimeWeeks: number | null;
  leadTimeNotes: string | null;
  note: string | null;
  quotePrices: QuotePrice[];
  isDuplicateQuoteLine?: boolean;
};

export type ImportedQuoteLine = ParsedQuoteLine & {
  part: Part;
  isPartNew: boolean;
};
